import type { TransactionEvent } from '@sentry/core'
import groupTransactions from './groupTransactions'

const buildBeforeSendTransaction = (
  event: TransactionEvent
): TransactionEvent => {
  let thisEvent = { ...event }
  thisEvent = groupTransactions(event)

  return thisEvent
}

export default buildBeforeSendTransaction
